var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.701 3.25C27.2783 2.25 28.7217 2.25 29.299 3.25L50.0836 39.25C50.661 40.25 49.9393 41.5 48.7846 41.5H7.21539C6.06069 41.5 5.339 40.25 5.91635 39.25L26.701 3.25Z",
    fill: "#FFF6C9",
    stroke: "#BCA634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.8001V29.4001",
    stroke: "#BCA634",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 33.6V36.4",
    stroke: "#BCA634",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.2527c8e07dc0cccdea26f8bfe4c5f093.svg";
export { ForwardRef as ReactComponent };